import { configInputConverter } from '@seu-converter';
import {
  SeuApiConverter,
  SeuGlobalParameter,
  SeuGlobalParameterApi,
  SeuGlobalParameterBase,
  SeuSaveGlobalParameterRequest,
} from '@seu-types';

export const globalParameterConverter: SeuApiConverter<
  SeuGlobalParameter,
  SeuGlobalParameterApi
> = {
  fromApi: (input) => {
    const base = globalParameterBaseConverter.fromApi(input);
    return {
      ...base,
      id: String(input.id),
      isDefault: input.defaultGlobalParameterSet ?? false,
    };
  },
  toApi: (input) => {
    const base = globalParameterBaseConverter.toApi(input);
    return {
      ...base,
      id: Number(input.id),
      defaultGlobalParameterSet: input.isDefault,
    };
  },
};

export const globalParameterBaseConverter: SeuApiConverter<
  SeuGlobalParameterBase,
  SeuSaveGlobalParameterRequest
> = {
  fromApi: (input) => {
    return {
      ...input,
      description: input.description ?? null,
      inputs:
        input.inputs?.map((configInput) => {
          return configInputConverter.fromApi(configInput);
        }) ?? [],
    };
  },
  toApi: (input) => {
    return {
      ...input,
      description: input.description ?? undefined,
      inputs:
        input.inputs.map((configInput) => {
          return configInputConverter.toApi(configInput);
        }) ?? [],
    };
  },
};
